import { Injectable, EventEmitter, Component, Output, Input, NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modal-iframe.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModalIframeService {
    constructor() {
        this.CargarNuevo = (/**
         * @param {?} direccion
         * @param {?} titulo
         * @param {?=} height
         * @param {?=} id
         * @param {?=} idLabel
         * @return {?}
         */
        (direccion, titulo, height = "477", id = "dialog", idLabel = "headerTextFileShare") => {
            // $("#dialog").attr("data-width", width);
            $(".contentDialog").css("height", height + "px");
            $(`#${id} iframe`).attr("src", direccion);
            //this.router.navigateByUrl("digitalizacion");
            $(`#${idLabel}`).html(titulo);
        });
    }
    /**
     * @param {?=} id
     * @return {?}
     */
    CloseModal(id = "dialog") {
        /** @type {?} */
        var dialog = $(`#${id}`).data('dialog');
        $(`#${id} iframe`).attr("src", "about:blank");
        dialog.close();
    }
    /**
     * @param {?=} id
     * @return {?}
     */
    ShowModal(id = "dialog") {
        //toggleMetroDialog("#dialog");
        metroDialog.toggle(`#${id}`);
    }
}
ModalIframeService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
ModalIframeService.ctorParameters = () => [];
if (false) {
    /** @type {?} */
    ModalIframeService.prototype.CargarNuevo;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modal-iframe.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var chance = require("chance").Chance();
class ModalIframeComponent {
    /**
     * @param {?} sanitizer
     */
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
        this.close = new EventEmitter();
        this.closeModal = (/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            var dialog = $(`#${this.id}`).data('dialog');
            this.url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
            this.close.emit();
            dialog.close();
            /** @type {?} */
            let controls = (/** @type {?} */ ($(".searchModal")));
            /** @type {?} */
            let elementos = null;
            for (let item of controls) {
                /** @type {?} */
                let visible = $(item).css("visibility");
                if (visible == "visible") {
                    elementos = visible;
                }
            }
            //let elementos = $(".searchModal").css("visibility");
            if (elementos != "visible") {
                $(`body`).css("overflow-y", "auto");
                //setTimeout(() => {
                //   // $(window).scrollTop(window["scrollLast"]);
                //}, 3)
            }
        });
        this.showModal = (/**
         * @param {?} direccion
         * @param {?=} contentDinamico
         * @return {?}
         */
        (direccion, contentDinamico = false) => {
            $(`#${this.idContent}`).css("height", this.height);
            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(direccion);
            //if (window["scrollLast"] == 0 || window["scrollLast"] == undefined) {
            //    window["scrollLast"] = $("body").scrollTop();
            //}
            $("body").css("overflow-y", "hidden");
            metroDialog.toggle(`#${this.id}`);
        });
        this.getIdClass = (/**
         * @return {?}
         */
        () => {
            this.id = chance.guid();
            this.idIframe = chance.guid();
            this.idContent = chance.guid();
        });
    }
    /**
     * @return {?}
     */
    get isContentDinamico() {
        return this._isContentDinamico;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.getIdClass();
        this.opDark = "op-dark";
        this._isContentDinamico = false;
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl("about:blank");
        if (this.height == undefined || this.height == null) {
            this.height = "500px";
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        $(`#${this.id}`).attr("data-role", "dialog"); //draggable
        //$(`#${this.id}`).attr("data-place", "top-center");
    }
}
ModalIframeComponent.decorators = [
    { type: Component, args: [{
                selector: 'modal-iframe-template',
                template: `
<div style="border: 2px solid;z-index: 1999 !important;" data-role="dialog" [attr.id]="id" class="grid searchModal" [attr.data-overlay]="true" 
  [attr.data-background]="'#fefefe'" [attr.data-close-button]="false" [attr.data-width]="width" [attr.data-overlay]="true" 
  [attr.data-overlay-click-close]="false" [attr.data-overlay-color]="opDark">
      <div class="headerDialog flex-grid">
          <div class="row cells12">
              <div class="sub-header cell colspan10 modalHeaderVesta">
                  <label id="headerText">{{tittle}}</label>
              </div>
              <div class="cell colspan2 modalHeaderVesta">
                  <img (click)="closeModal()" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAADdAAAA3QFwU6IHAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAQtQTFRF////JJLbIIC/IIDKH4XMHILMH4XOH4PPHoTOHoXOHoTOH4XPIITOH4XOH4TNH4TOH4TOH4TOJYfPOJHTOZLUSZrWS5zYZanaaa3edrLdfbjjjLzgjb7hjb7ilsXomMfpsM/mudbswdjpw97y0eDs2eTt2er32uXt2+Xt3Obt3ebt3ebu3efu393l3+jw4d/l4erw4urw48zV5cfQ5e/36O7z6O/z6e/06vD07PT67fL27/b88fX48vX58/b59I+d9Y2b9e3w9ff69fj69oqY9vn79/n7+Pr7+fv8+tzh+3aG+9fc+/3+/I6b/JKf/JSh/f7+/f7//tnd/t/j/v7+/v7///T1//7/////THgr+QAAABF0Uk5TAAcIGBktSYSXmMHI2uPy8/XVqDFbAAAB2klEQVQ4jYVT11YCQQxdEOlVOiIgfaUjRQXpiiwoRcH8/5eYZNgF9HjIw0Bys8nNnYwkaaYzWqx2l8tutRh10l8zmJ0ezZxmwy9Yb3J7Tsxt0h/jFzbPH7NdHPBLB4e8wetEOp24DnrZdVxq3zN+Fc3L8l2tdifL+egVZ+xr6Lm+Pym3utMtwHbabclJP3cRPEz0P5ypvoJmr9VMmKImno/4+3NPWziy7VOOarhpWjP1T3YBvjefAv3cfAN0k8TDjPqRPtEm4h+KstwB7JaK8oEZzSgpppOMNF95BbBR0N53u3f63QCsyjStUbLgGXzBwjOFMxhXZhh4CSJkkax43lDnXl/RrN+jyA1CVsmO5y25X5WJik8qXxS5RcguufBsMPlxaZ8xKY050EDIxQmPYryhmjAU/iMnUIsU+4K/mIUDKW5BJGPsLw8klxyIMUkaM8T6ifKiDWsa4jFJKN8a3bngJ5jOMbD2sVAsdRz95wHOXxqPS6jH4BkDcSG1uKwsSlu8rxdGAKNC/b6I0mf3lyWuO7AAmLYf3qj120N7CrAIqNctFiaygBNbRLSF2a9cIHuMZwNHK6cubXytwuv4ydJqa+8LxVKdTioW8v1a+/MP5/zTO/94/3/+Px4gl/0Dnu+pAAAAAElFTkSuQmCC" />
              </div>
          </div>
      </div>
      <div style="margin:5px;" [ngClass]="{'contentDialog': isContentDinamico }" >
          <div [attr.id]="idContent" class="contentDinamico" [ngStyle]="{'height': height}">
              <iframe [src]="url" [height]="height" width="100%" ></iframe>
          </div>        
      </div>    
  </div>
  `
            }] }
];
/** @nocollapse */
ModalIframeComponent.ctorParameters = () => [
    { type: DomSanitizer }
];
ModalIframeComponent.propDecorators = {
    close: [{ type: Output, args: ["close",] }],
    tittle: [{ type: Input, args: ["tittle",] }],
    width: [{ type: Input, args: ["width-modal",] }],
    height: [{ type: Input, args: ["height-modal",] }]
};
if (false) {
    /** @type {?} */
    ModalIframeComponent.prototype.id;
    /** @type {?} */
    ModalIframeComponent.prototype.idContent;
    /** @type {?} */
    ModalIframeComponent.prototype.idIframe;
    /** @type {?} */
    ModalIframeComponent.prototype.opDark;
    /** @type {?} */
    ModalIframeComponent.prototype.url;
    /** @type {?} */
    ModalIframeComponent.prototype.close;
    /** @type {?} */
    ModalIframeComponent.prototype.tittle;
    /** @type {?} */
    ModalIframeComponent.prototype.width;
    /** @type {?} */
    ModalIframeComponent.prototype.height;
    /**
     * @type {?}
     * @private
     */
    ModalIframeComponent.prototype._isContentDinamico;
    /** @type {?} */
    ModalIframeComponent.prototype.closeModal;
    /** @type {?} */
    ModalIframeComponent.prototype.showModal;
    /**
     * @type {?}
     * @private
     */
    ModalIframeComponent.prototype.getIdClass;
    /**
     * @type {?}
     * @private
     */
    ModalIframeComponent.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modal-iframe.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModalIframeModule {
}
ModalIframeModule.decorators = [
    { type: NgModule, args: [{
                declarations: [ModalIframeComponent],
                imports: [CommonModule],
                exports: [ModalIframeComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: modal-iframe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ModalIframeComponent, ModalIframeModule, ModalIframeService };
//# sourceMappingURL=modal-iframe.js.map
